export default "__VITE_ASSET__BAzdkEGD__"